import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, vModelRadio as _vModelRadio, withDirectives as _withDirectives, createTextVNode as _createTextVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, resolveDirective as _resolveDirective, createBlock as _createBlock, createStaticVNode as _createStaticVNode } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "d-flex flex-wrap flex-stack pb-7"
}
const _hoisted_2 = { class: "d-flex flex-wrap align-items-center my-1" }
const _hoisted_3 = {
  key: 0,
  class: "d-flex"
}
const _hoisted_4 = /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder me-5 my-1" }, "People", -1)
const _hoisted_5 = [
  _hoisted_4
]
const _hoisted_6 = {
  key: 1,
  class: "d-flex"
}
const _hoisted_7 = { class: "fw-bolder me-5 my-1" }
const _hoisted_8 = {
  key: 2,
  class: "d-flex"
}
const _hoisted_9 = { class: "fw-bolder me-5 my-1" }
const _hoisted_10 = {
  key: 3,
  class: "d-flex"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder me-5 my-1" }, "Groups", -1)
const _hoisted_12 = [
  _hoisted_11
]
const _hoisted_13 = {
  key: 4,
  class: "d-flex"
}
const _hoisted_14 = /*#__PURE__*/_createElementVNode("h3", { class: "fw-bolder me-5 my-1" }, "Measurements", -1)
const _hoisted_15 = [
  _hoisted_14
]
const _hoisted_16 = {
  key: 0,
  class: "d-flex my-1"
}
const _hoisted_17 = { class: "btn-group me-6 mb-2" }
const _hoisted_18 = {
  key: 0,
  class: "me-4 d-none d-md-flex"
}
const _hoisted_19 = {
  key: 1,
  class: "d-flex my-1"
}
const _hoisted_20 = { class: "nav nav-pills me-6 mb-2 mb-sm-0" }
const _hoisted_21 = { class: "nav-item m-0" }
const _hoisted_22 = /*#__PURE__*/_createElementVNode("i", { class: "fad fa-inbox-in" }, null, -1)
const _hoisted_23 = { class: "nav-item m-0" }
const _hoisted_24 = /*#__PURE__*/_createElementVNode("i", { class: "fad fa-inbox-out" }, null, -1)
const _hoisted_25 = {
  key: 2,
  class: "d-flex flex-wrap my-1 d-none d-md-block"
}
const _hoisted_26 = {
  key: 3,
  class: "d-flex"
}
const _hoisted_27 = {
  key: 0,
  class: "my-0 d-none d-md-flex"
}
const _hoisted_28 = { class: "tab-content" }
const _hoisted_29 = {
  key: 0,
  id: "people_card_pane",
  class: "tab-pane fade active show"
}
const _hoisted_30 = { class: "row g-6 g-xl-9" }
const _hoisted_31 = { class: "card" }
const _hoisted_32 = { class: "card-body d-flex align-items-center p-4" }
const _hoisted_33 = { class: "symbol symbol-65px symbol-circle me-4" }
const _hoisted_34 = {
  key: 0,
  class: "symbol-label fs-2x fw-bold text-white bg-light-primary"
}
const _hoisted_35 = ["src"]
const _hoisted_36 = { class: "d-flex flex-column mt-3 mt-md-6" }
const _hoisted_37 = ["onClick"]
const _hoisted_38 = {
  key: 1,
  class: "fs-3 text-gray-900 fw-bolder mb-0 text-wrap"
}
const _hoisted_39 = { class: "fs-7 text-gray-700 fw-bolder mb-0" }
const _hoisted_40 = { class: "fs-4 fw-bold text-gray-800 mb-md-6" }
const _hoisted_41 = {
  key: 2,
  class: "d-flex flex-center flex-wrap"
}
const _hoisted_42 = { class: "border border-gray-400 border-dashed rounded min-w-80px py-3 px-4 mx-2 mb-3" }
const _hoisted_43 = { class: "fs-6 fw-bolder text-gray-800" }
const _hoisted_44 = /*#__PURE__*/_createElementVNode("div", { class: "fw-bold text-gray-500" }, "Role", -1)
const _hoisted_45 = {
  key: 1,
  id: "people_list_pane",
  class: "tab-pane fade active show"
}
const _hoisted_46 = { class: "card card-flush" }
const _hoisted_47 = { class: "card-body pt-0" }
const _hoisted_48 = { class: "table-responsive" }
const _hoisted_49 = {
  id: "kt_project_users_table_wrapper",
  class: "dataTables_wrapper dt-bootstrap4 no-footer"
}
const _hoisted_50 = { class: "table-responsive" }
const _hoisted_51 = {
  id: "kt_project_users_table",
  class: "table table-row-bordered table-row-dashed gy-4 align-middle fw-bolder dataTable no-footer",
  role: "grid",
  "aria-label": "List of all users with access to this entity."
}
const _hoisted_52 = /*#__PURE__*/_createElementVNode("thead", { class: "fs-7 text-gray-800 text-uppercase" }, [
  /*#__PURE__*/_createElementVNode("tr", { role: "row" }, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "sorting",
      tabindex: "0",
      "aria-controls": "kt_project_users_table",
      rowspan: "1",
      colspan: "1",
      style: {"width":"0px"},
      "aria-label": "Manager: activate to sort column ascending"
    }, " Name "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "sorting",
      tabindex: "0",
      "aria-controls": "kt_project_users_table",
      rowspan: "1",
      colspan: "1",
      style: {"width":"0px"},
      "aria-label": "Date: activate to sort column ascending"
    }, "Title "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "sorting d-none d-md-table-cell",
      tabindex: "0",
      "aria-controls": "kt_project_users_table",
      rowspan: "1",
      colspan: "1",
      style: {"width":"0px"},
      "aria-label": "Amount: activate to sort column ascending"
    }, "Groups "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "sorting d-none d-md-table-cell",
      tabindex: "0",
      "aria-controls": "kt_project_users_table",
      rowspan: "1",
      colspan: "1",
      style: {"width":"0px"},
      "aria-label": "Amount: activate to sort column ascending"
    }, "Role "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "sorting d-none d-md-table-cell",
      tabindex: "0",
      "aria-controls": "kt_project_users_table",
      rowspan: "1",
      colspan: "1",
      style: {"width":"0px"},
      "aria-label": "Status: activate to sort column ascending"
    }, "Status "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "text-end sorting_disabled d-none d-md-table-cell",
      rowspan: "1",
      colspan: "1",
      style: {"width":"0px"},
      "aria-label": "Details"
    }, "Actions ")
  ])
], -1)
const _hoisted_53 = { class: "fs-6" }
const _hoisted_54 = { class: "d-flex align-items-center" }
const _hoisted_55 = { class: "me-5 position-relative" }
const _hoisted_56 = { class: "symbol symbol-35px symbol-circle" }
const _hoisted_57 = {
  key: 0,
  class: "symbol-label bg-light-primary text-white fw-bold"
}
const _hoisted_58 = ["src"]
const _hoisted_59 = { class: "d-flex flex-column justify-content-center" }
const _hoisted_60 = ["onClick"]
const _hoisted_61 = { class: "fw-bold fs-6 text-gray-600" }
const _hoisted_62 = { class: "d-none d-md-table-cell" }
const _hoisted_63 = { class: "d-none d-md-table-cell" }
const _hoisted_64 = { class: "d-none d-md-table-cell" }
const _hoisted_65 = { class: "text-end d-none d-md-table-cell" }
const _hoisted_66 = /*#__PURE__*/_createElementVNode("i", { class: "fad fa-pencil fs-3" }, null, -1)
const _hoisted_67 = /*#__PURE__*/_createElementVNode("i", { class: "fad fa-trash fs-3" }, null, -1)
const _hoisted_68 = /*#__PURE__*/_createStaticVNode("<div class=\"row d-none\"><div class=\"col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start\"><div class=\"dataTables_length\" id=\"kt_project_users_table_length\"><label><select name=\"kt_project_users_table_length\" aria-controls=\"kt_project_users_table\" class=\"form-select form-select-sm form-select-solid\"><option value=\"10\">10</option><option value=\"25\">25</option><option value=\"50\">50</option><option value=\"100\">100</option></select></label></div></div><div class=\"col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end\"><div class=\"dataTables_paginate paging_simple_numbers\" id=\"kt_project_users_table_paginate\"><ul class=\"pagination\"><li class=\"paginate_button page-item previous disabled\" id=\"kt_project_users_table_previous\"><a href=\"#\" aria-controls=\"kt_project_users_table\" data-dt-idx=\"0\" tabindex=\"0\" class=\"page-link\"><i class=\"previous\"></i></a></li><li class=\"paginate_button page-item active\"><a href=\"#\" aria-controls=\"kt_project_users_table\" data-dt-idx=\"1\" tabindex=\"0\" class=\"page-link\">1</a></li><li class=\"paginate_button page-item\"><a href=\"#\" aria-controls=\"kt_project_users_table\" data-dt-idx=\"2\" tabindex=\"0\" class=\"page-link\">2</a></li><li class=\"paginate_button page-item\"><a href=\"#\" aria-controls=\"kt_project_users_table\" data-dt-idx=\"3\" tabindex=\"0\" class=\"page-link\">3</a></li><li class=\"paginate_button page-item next\" id=\"kt_project_users_table_next\"><a href=\"#\" aria-controls=\"kt_project_users_table\" data-dt-idx=\"4\" tabindex=\"0\" class=\"page-link\"><i class=\"next\"></i></a></li></ul></div></div></div>", 1)
const _hoisted_69 = {
  key: 2,
  id: "requests_list_pane",
  class: "tab-pane fade active show"
}
const _hoisted_70 = { class: "card card-flush" }
const _hoisted_71 = { class: "card-body pt-0" }
const _hoisted_72 = /*#__PURE__*/_createElementVNode("i", { class: "fad fa-inbox-in fa-4x" }, null, -1)
const _hoisted_73 = /*#__PURE__*/_createElementVNode("i", { class: "fad fa-inbox-out fa-4x" }, null, -1)
const _hoisted_74 = {
  key: 2,
  class: "table-responsive"
}
const _hoisted_75 = {
  id: "requests_table_wrapper",
  class: "dataTables_wrapper dt-bootstrap4 no-footer"
}
const _hoisted_76 = { class: "table-responsive" }
const _hoisted_77 = {
  id: "requests_table",
  class: "table table-row-bordered table-row-dashed gy-4 align-middle fw-bolder dataTable no-footer",
  role: "grid",
  "aria-label": "List of all users with access to this entity."
}
const _hoisted_78 = /*#__PURE__*/_createElementVNode("thead", { class: "fs-7 text-gray-400 text-uppercase" }, [
  /*#__PURE__*/_createElementVNode("tr", { role: "row" }, [
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "min-w-md-250px sorting",
      tabindex: "0",
      "aria-controls": "kt_project_users_table",
      rowspan: "1",
      colspan: "1",
      style: {"width":"0px"},
      "aria-label": "Manager: activate to sort column ascending"
    }, " Name "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "min-w-md-150px sorting",
      tabindex: "0",
      "aria-controls": "kt_project_users_table",
      rowspan: "1",
      colspan: "1",
      style: {"width":"0px"},
      "aria-label": "Date: activate to sort column ascending"
    }, "Title "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "min-w-md-90px sorting d-none d-md-table-cell",
      tabindex: "0",
      "aria-controls": "kt_project_users_table",
      rowspan: "1",
      colspan: "1",
      style: {"width":"0px"},
      "aria-label": "Amount: activate to sort column ascending"
    }, "Role "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "min-w-md-90px sorting d-none d-md-table-cell",
      tabindex: "0",
      "aria-controls": "kt_project_users_table",
      rowspan: "1",
      colspan: "1",
      style: {"width":"0px"},
      "aria-label": "Status: activate to sort column ascending"
    }, "Status "),
    /*#__PURE__*/_createElementVNode("th", {
      scope: "col",
      class: "min-w-md-50px text-end sorting_disabled d-none d-md-table-cell",
      rowspan: "1",
      colspan: "1",
      style: {"width":"0px"},
      "aria-label": "Details"
    }, "Actions ")
  ])
], -1)
const _hoisted_79 = {
  key: 0,
  class: "fs-6"
}
const _hoisted_80 = { class: "d-flex align-items-center" }
const _hoisted_81 = { class: "me-5 position-relative" }
const _hoisted_82 = {
  key: 0,
  class: "symbol symbol-35px symbol-circle"
}
const _hoisted_83 = {
  key: 0,
  class: "symbol-label bg-light-danger text-danger fw-bold"
}
const _hoisted_84 = ["src"]
const _hoisted_85 = {
  key: 1,
  class: "symbol symbol-35px symbol-circle"
}
const _hoisted_86 = {
  key: 0,
  class: "symbol-label bg-light-danger text-danger fw-bold"
}
const _hoisted_87 = ["src"]
const _hoisted_88 = { class: "d-flex flex-column justify-content-center" }
const _hoisted_89 = ["onClick"]
const _hoisted_90 = { class: "fw-bold fs-6 text-gray-600" }
const _hoisted_91 = { class: "d-none d-md-table-cell" }
const _hoisted_92 = { class: "d-none d-md-table-cell" }
const _hoisted_93 = { class: "text-end d-none d-md-table-cell" }
const _hoisted_94 = /*#__PURE__*/_createElementVNode("i", { class: "fad fa-check-double fs-3" }, null, -1)
const _hoisted_95 = {
  key: 1,
  class: "fs-6"
}
const _hoisted_96 = { class: "d-flex align-items-center" }
const _hoisted_97 = { class: "me-5 position-relative" }
const _hoisted_98 = {
  key: 0,
  class: "symbol symbol-35px symbol-circle"
}
const _hoisted_99 = {
  key: 0,
  class: "symbol-label bg-light-danger text-danger fw-bold"
}
const _hoisted_100 = ["src"]
const _hoisted_101 = {
  key: 1,
  class: "symbol symbol-35px symbol-circle"
}
const _hoisted_102 = {
  key: 0,
  class: "symbol-label bg-light-danger text-danger fw-bold"
}
const _hoisted_103 = ["src"]
const _hoisted_104 = {
  key: 0,
  class: "d-flex flex-column justify-content-center"
}
const _hoisted_105 = { class: "mb-1 text-gray-800 text-hover-primary" }
const _hoisted_106 = { class: "fw-bold fs-6 text-gray-600" }
const _hoisted_107 = {
  key: 1,
  class: "d-flex flex-column justify-content-center"
}
const _hoisted_108 = { class: "mb-1 text-gray-800 text-hover-primary" }
const _hoisted_109 = { class: "fw-bold fs-6 text-gray-600" }
const _hoisted_110 = { class: "d-none d-md-table-cell" }
const _hoisted_111 = { class: "d-none d-md-table-cell" }
const _hoisted_112 = { class: "text-end d-none d-md-table-cell" }
const _hoisted_113 = /*#__PURE__*/_createElementVNode("i", { class: "fad fa-check-double fs-3" }, null, -1)
const _hoisted_114 = /*#__PURE__*/_createElementVNode("i", { class: "fad fa-trash fs-3" }, null, -1)
const _hoisted_115 = /*#__PURE__*/_createElementVNode("i", { class: "fad fa-alarm-clock fs-3" }, null, -1)
const _hoisted_116 = /*#__PURE__*/_createStaticVNode("<div class=\"row d-none\"><div class=\"col-sm-12 col-md-5 d-flex align-items-center justify-content-center justify-content-md-start\"><div class=\"dataTables_length\" id=\"requests_table_length\"><label><select name=\"requests_table_length\" aria-controls=\"requests_table\" class=\"form-select form-select-sm form-select-solid\"><option value=\"10\">10</option><option value=\"25\">25</option><option value=\"50\">50</option><option value=\"100\">100</option></select></label></div></div><div class=\"col-sm-12 col-md-7 d-flex align-items-center justify-content-center justify-content-md-end\"><div class=\"dataTables_paginate paging_simple_numbers\" id=\"requests_table_paginate\"><ul class=\"pagination\"><li class=\"paginate_button page-item previous disabled\" id=\"requests_table_previous\"><a href=\"#\" aria-controls=\"requests_table\" data-dt-idx=\"0\" tabindex=\"0\" class=\"page-link\"><i class=\"previous\"></i></a></li><li class=\"paginate_button page-item active\"><a href=\"#\" aria-controls=\"requests_table\" data-dt-idx=\"1\" tabindex=\"0\" class=\"page-link\">1</a></li><li class=\"paginate_button page-item\"><a href=\"#\" aria-controls=\"requests_table\" data-dt-idx=\"2\" tabindex=\"0\" class=\"page-link\">2</a></li><li class=\"paginate_button page-item\"><a href=\"#\" aria-controls=\"requests_table\" data-dt-idx=\"3\" tabindex=\"0\" class=\"page-link\">3</a></li><li class=\"paginate_button page-item next\" id=\"requests_table_next\"><a href=\"#\" aria-controls=\"requests_table\" data-dt-idx=\"4\" tabindex=\"0\" class=\"page-link\"><i class=\"next\"></i></a></li></ul></div></div></div>", 1)
const _hoisted_117 = {
  key: 3,
  id: "group_list_pane",
  class: "tab-pane fade active show"
}
const _hoisted_118 = { class: "card card-flush" }
const _hoisted_119 = { class: "card-body pt-0" }
const _hoisted_120 = /*#__PURE__*/_createElementVNode("i", { class: "fad fa-users fa-4x" }, null, -1)
const _hoisted_121 = {
  class: "py-0",
  "data-kt-customer-payment-method": "row"
}
const _hoisted_122 = { class: "py-3 d-flex flex-stack flex-wrap" }
const _hoisted_123 = ["href"]
const _hoisted_124 = /*#__PURE__*/_createElementVNode("div", { class: "me-3 rotate-90" }, [
  /*#__PURE__*/_createElementVNode("span", { class: "svg-icon svg-icon-3" }, [
    /*#__PURE__*/_createElementVNode("svg", {
      xmlns: "http://www.w3.org/2000/svg",
      width: "24",
      height: "24",
      viewBox: "0 0 24 24",
      fill: "none"
    }, [
      /*#__PURE__*/_createElementVNode("path", {
        d: "M12.6343 12.5657L8.45001 16.75C8.0358 17.1642 8.0358 17.8358 8.45001 18.25C8.86423 18.6642 9.5358 18.6642 9.95001 18.25L15.4929 12.7071C15.8834 12.3166 15.8834 11.6834 15.4929 11.2929L9.95001 5.75C9.5358 5.33579 8.86423 5.33579 8.45001 5.75C8.0358 6.16421 8.0358 6.83579 8.45001 7.25L12.6343 11.4343C12.9467 11.7467 12.9467 12.2533 12.6343 12.5657Z",
        fill: "black"
      })
    ])
  ])
], -1)
const _hoisted_125 = { class: "me-3" }
const _hoisted_126 = ["onClick"]
const _hoisted_127 = { class: "text-gray-800 fw-bolder" }
const _hoisted_128 = { class: "text-muted" }
const _hoisted_129 = {
  class: "d-flex my-3 ms-9",
  "element-loading-text": "Generating PDF"
}
const _hoisted_130 = ["id"]
const _hoisted_131 = { class: "d-flex flex-wrap" }
const _hoisted_132 = /*#__PURE__*/_createElementVNode("div", { class: "separator separator-dashed" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_Button = _resolveComponent("Button")!
  const _component_el_empty = _resolveComponent("el-empty")!
  const _component_VerticalBullet = _resolveComponent("VerticalBullet")!
  const _component_MeasurementsTable = _resolveComponent("MeasurementsTable")!
  const _component_ManagePersonModal = _resolveComponent("ManagePersonModal")!
  const _component_GroupModal = _resolveComponent("GroupModal")!
  const _component_AddPeopleModal = _resolveComponent("AddPeopleModal")!
  const _component_EntityRequestModal = _resolveComponent("EntityRequestModal")!
  const _component_ViewPersonModal = _resolveComponent("ViewPersonModal")!
  const _directive_loading = _resolveDirective("loading")!

  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.userStore.canManage(_ctx.userStore.currentEntity))
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", _hoisted_2, [
            (_ctx.applicationStore.peopleCurrentTab === 'members')
              ? (_openBlock(), _createElementBlock("div", _hoisted_3, _hoisted_5))
              : _createCommentVNode("", true),
            (_ctx.applicationStore.peopleCurrentTab === 'requests' && _ctx.activeRequestsTab === 'requests')
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  _createElementVNode("h3", _hoisted_7, "Incoming Requests (" + _toDisplayString(_ctx.pendingRequests.length) + ")", 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.applicationStore.peopleCurrentTab === 'requests' && _ctx.activeRequestsTab === 'invitations')
              ? (_openBlock(), _createElementBlock("div", _hoisted_8, [
                  _createElementVNode("h3", _hoisted_9, "Outgoing Invitations (" + _toDisplayString(_ctx.pendingInvitations.length) + ")", 1)
                ]))
              : _createCommentVNode("", true),
            (_ctx.applicationStore.peopleCurrentTab === 'groups')
              ? (_openBlock(), _createElementBlock("div", _hoisted_10, _hoisted_12))
              : _createCommentVNode("", true),
            (_ctx.applicationStore.peopleCurrentTab === 'measurements')
              ? (_openBlock(), _createElementBlock("div", _hoisted_13, _hoisted_15))
              : _createCommentVNode("", true)
          ]),
          (_ctx.applicationStore.peopleCurrentTab === 'members')
            ? (_openBlock(), _createElementBlock("div", _hoisted_16, [
                _createElementVNode("div", _hoisted_17, [
                  _createElementVNode("label", {
                    onClick: _cache[1] || (_cache[1] = ($event: any) => (_ctx.activeTab = 'grid')),
                    class: _normalizeClass(["btn btn-outline-secondary text-white text-hover-white text-active-white btn-outline btn-active-primary", {'active': _ctx.activeTab === 'grid'}])
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.activeTab) = $event)),
                      class: "btn-check",
                      type: "radio",
                      name: "method",
                      value: "grid"
                    }, null, 512), [
                      [_vModelRadio, _ctx.activeTab]
                    ]),
                    _createTextVNode(" Grid ")
                  ], 2),
                  _createElementVNode("label", {
                    onClick: _cache[3] || (_cache[3] = ($event: any) => (_ctx.activeTab = 'list')),
                    class: _normalizeClass(["btn btn-outline-secondary text-white text-hover-white text-active-white btn-outline btn-active-primary", {'active': _ctx.activeTab === 'list'}])
                  }, [
                    _withDirectives(_createElementVNode("input", {
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_ctx.activeTab) = $event)),
                      class: "btn-check",
                      type: "radio",
                      name: "method",
                      value: "list"
                    }, null, 512), [
                      [_vModelRadio, _ctx.activeTab]
                    ]),
                    _createTextVNode(" List ")
                  ], 2)
                ]),
                (_ctx.userStore.canManage(_ctx.userStore.currentEntity) && !_ctx.isOrganization)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_18, [
                      _createVNode(_component_Button, {
                        onClick: _cache[4] || (_cache[4] = ($event: any) => (_ctx.requestExport(_ctx.groups.map(g => g.groupId)))),
                        "is-loading": _ctx.exportLoading,
                        class: "btn-sm btn-secondary"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("export to pdf ")
                        ]),
                        _: 1
                      }, 8, ["is-loading"])
                    ]))
                  : _createCommentVNode("", true),
                _createVNode(_component_Button, {
                  onClick: _ctx.invokeAddPeople,
                  class: "btn-sm me-4"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Add People")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.applicationStore.peopleCurrentTab === 'requests')
            ? (_openBlock(), _createElementBlock("div", _hoisted_19, [
                _createElementVNode("ul", _hoisted_20, [
                  _createElementVNode("li", _hoisted_21, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["btn btn-sm btn-light btn-color-muted btn-active-primary me-3", {'active': _ctx.activeRequestsTab === 'requests'}]),
                      onClick: _cache[5] || (_cache[5] = ($event: any) => (_ctx.activeRequestsTab = 'requests'))
                    }, [
                      _hoisted_22,
                      _createTextVNode(" Incoming Requests ")
                    ], 2)
                  ]),
                  _createElementVNode("li", _hoisted_23, [
                    _createElementVNode("div", {
                      class: _normalizeClass(["btn btn-sm btn-light btn-color-muted btn-active-primary me-3", {'active': _ctx.activeRequestsTab === 'invitations'}]),
                      onClick: _cache[6] || (_cache[6] = ($event: any) => (_ctx.activeRequestsTab = 'invitations'))
                    }, [
                      _hoisted_24,
                      _createTextVNode(" Outgoing Invitations ")
                    ], 2)
                  ])
                ]),
                _createVNode(_component_Button, {
                  onClick: _ctx.invokeAddPeople,
                  class: "btn-sm me-4"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Add People")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.applicationStore.peopleCurrentTab === 'groups')
            ? (_openBlock(), _createElementBlock("div", _hoisted_25, [
                _createVNode(_component_Button, {
                  onClick: _ctx.invokeAddGroup,
                  class: "btn-sm"
                }, {
                  default: _withCtx(() => [
                    _createTextVNode("Add Group")
                  ]),
                  _: 1
                }, 8, ["onClick"])
              ]))
            : _createCommentVNode("", true),
          (_ctx.applicationStore.peopleCurrentTab === 'measurements')
            ? (_openBlock(), _createElementBlock("div", _hoisted_26, [
                (_ctx.userStore.canManage(_ctx.userStore.currentEntity) && !_ctx.isOrganization)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                      _createVNode(_component_Button, {
                        onClick: _cache[7] || (_cache[7] = ($event: any) => (_ctx.requestMeasurementExport(_ctx.groups.map(g => g.groupId)))),
                        "is-loading": _ctx.exportLoading,
                        class: "btn-sm"
                      }, {
                        default: _withCtx(() => [
                          _createTextVNode("export to pdf ")
                        ]),
                        _: 1
                      }, 8, ["is-loading"])
                    ]))
                  : _createCommentVNode("", true)
              ]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    _createElementVNode("div", _hoisted_28, [
      (_ctx.applicationStore.peopleCurrentTab === 'members' && _ctx.activeTab === 'grid')
        ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_29, [
            _createElementVNode("div", _hoisted_30, [
              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activePeople, (person) => {
                return (_openBlock(), _createElementBlock("div", {
                  class: "col-12 col-md-4",
                  key: person.accountId
                }, [
                  _createElementVNode("div", _hoisted_31, [
                    _createElementVNode("div", _hoisted_32, [
                      _createElementVNode("div", _hoisted_33, [
                        (!person.avatar)
                          ? (_openBlock(), _createElementBlock("span", _hoisted_34, _toDisplayString(person.fullName[0]), 1))
                          : (_openBlock(), _createElementBlock("img", {
                              key: 1,
                              src: person.avatar,
                              alt: "image"
                            }, null, 8, _hoisted_35))
                      ]),
                      _createElementVNode("div", _hoisted_36, [
                        (_ctx.userStore.canManage(_ctx.userStore.currentEntity))
                          ? (_openBlock(), _createElementBlock("div", {
                              key: 0,
                              class: _normalizeClass(["fs-4 text-gray-900 fw-bolder mb-0", {'cursor-pointer text-hover-primary': _ctx.userStore.canManage(_ctx.userStore.currentEntity)}]),
                              onClick: ($event: any) => (_ctx.invokeViewPerson(person.accountId))
                            }, _toDisplayString(person.fullName), 11, _hoisted_37))
                          : (_openBlock(), _createElementBlock("div", _hoisted_38, [
                              _createTextVNode(_toDisplayString(person.fullName) + " ", 1),
                              _createElementVNode("span", _hoisted_39, _toDisplayString(person.pronouns), 1)
                            ])),
                        _createElementVNode("div", _hoisted_40, _toDisplayString(person.title), 1),
                        false
                          ? (_openBlock(), _createElementBlock("div", _hoisted_41, [
                              _createElementVNode("div", _hoisted_42, [
                                _createElementVNode("div", _hoisted_43, _toDisplayString(_ctx.getRole(person.role).name), 1),
                                _hoisted_44
                              ])
                            ]))
                          : _createCommentVNode("", true)
                      ])
                    ])
                  ])
                ]))
              }), 128))
            ])
          ])), [
            [_directive_loading, _ctx.peopleLoading]
          ])
        : _createCommentVNode("", true),
      (_ctx.applicationStore.peopleCurrentTab === 'members' && _ctx.activeTab === 'list')
        ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_45, [
            _createElementVNode("div", _hoisted_46, [
              _createElementVNode("div", _hoisted_47, [
                _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_48, [
                  _createElementVNode("div", _hoisted_49, [
                    _createElementVNode("div", _hoisted_50, [
                      _createElementVNode("table", _hoisted_51, [
                        _hoisted_52,
                        _createElementVNode("tbody", _hoisted_53, [
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.activePeople, (person) => {
                            return (_openBlock(), _createElementBlock("tr", {
                              class: "odd",
                              key: person.accountId
                            }, [
                              _createElementVNode("td", null, [
                                _createElementVNode("div", _hoisted_54, [
                                  _createElementVNode("div", _hoisted_55, [
                                    _createElementVNode("div", _hoisted_56, [
                                      (!person.avatar)
                                        ? (_openBlock(), _createElementBlock("span", _hoisted_57, _toDisplayString(person.fullName[0]), 1))
                                        : (_openBlock(), _createElementBlock("img", {
                                            key: 1,
                                            alt: "Pic",
                                            src: person.avatar
                                          }, null, 8, _hoisted_58))
                                    ])
                                  ]),
                                  _createElementVNode("div", _hoisted_59, [
                                    _createElementVNode("a", {
                                      onClick: ($event: any) => (_ctx.invokeViewPerson(person.accountId)),
                                      class: "mb-1 text-gray-800 text-hover-primary cursor-pointer"
                                    }, _toDisplayString(person.fullName), 9, _hoisted_60),
                                    _createElementVNode("div", _hoisted_61, _toDisplayString(person.pronouns), 1)
                                  ])
                                ])
                              ]),
                              _createElementVNode("td", null, _toDisplayString(person.title), 1),
                              _createElementVNode("td", _hoisted_62, [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.getPersonsGroups(person.accountId), (group) => {
                                  return (_openBlock(), _createElementBlock("span", {
                                    key: group.groupId,
                                    class: "badge badge-light-primary text-white me-2 mb-2 px-4 py-3"
                                  }, _toDisplayString(group.name), 1))
                                }), 128))
                              ]),
                              _createElementVNode("td", _hoisted_63, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(`badge badge-light-${_ctx.getRole(person.role).class} text-white fw-bolder px-4 py-3`)
                                }, _toDisplayString(_ctx.getRole(person.role).name), 3)
                              ]),
                              _createElementVNode("td", _hoisted_64, [
                                _createElementVNode("span", {
                                  class: _normalizeClass(`badge badge-light-${_ctx.getStatus(person.status).class} text-white fw-bolder px-4 py-3`)
                                }, _toDisplayString(_ctx.getStatus(person.status).name), 3)
                              ]),
                              _createElementVNode("td", _hoisted_65, [
                                _createElementVNode("div", null, [
                                  _createVNode(_component_Button, {
                                    onClick: ($event: any) => (_ctx.invokeManagePerson(person)),
                                    type: "",
                                    class: "btn-link btn-active-color-primary me-4"
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_66
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]),
                                  _createVNode(_component_Button, {
                                    onClick: ($event: any) => (_ctx.removePerson(person)),
                                    class: "btn-link me-lg-2 btn-active-color-danger",
                                    type: ""
                                  }, {
                                    default: _withCtx(() => [
                                      _hoisted_67
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"])
                                ])
                              ])
                            ]))
                          }), 128))
                        ])
                      ])
                    ]),
                    _hoisted_68
                  ])
                ])), [
                  [_directive_loading, _ctx.peopleLoading]
                ])
              ])
            ])
          ])), [
            [_directive_loading, _ctx.peopleLoading]
          ])
        : _createCommentVNode("", true),
      (_ctx.applicationStore.peopleCurrentTab === 'requests')
        ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_69, [
            _createElementVNode("div", _hoisted_70, [
              _createElementVNode("div", _hoisted_71, [
                (_ctx.pendingRequests.length === 0 && _ctx.activeRequestsTab === 'requests')
                  ? (_openBlock(), _createBlock(_component_el_empty, {
                      key: 0,
                      description: "You don't have any incoming requests."
                    }, {
                      image: _withCtx(() => [
                        _hoisted_72
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                (_ctx.pendingInvitations.length === 0 && _ctx.activeRequestsTab === 'invitations')
                  ? (_openBlock(), _createBlock(_component_el_empty, {
                      key: 1,
                      description: "You don't have any outgoing invites."
                    }, {
                      image: _withCtx(() => [
                        _hoisted_73
                      ]),
                      _: 1
                    }))
                  : _createCommentVNode("", true),
                ((_ctx.pendingRequests.length > 0 && _ctx.activeRequestsTab === 'requests') || (_ctx.pendingInvitations.length > 0 && _ctx.activeRequestsTab === 'invitations'))
                  ? (_openBlock(), _createElementBlock("div", _hoisted_74, [
                      _createElementVNode("div", _hoisted_75, [
                        _createElementVNode("div", _hoisted_76, [
                          _createElementVNode("table", _hoisted_77, [
                            _hoisted_78,
                            (_ctx.activeRequestsTab === 'requests')
                              ? (_openBlock(), _createElementBlock("tbody", _hoisted_79, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pendingRequests, (person) => {
                                    return (_openBlock(), _createElementBlock("tr", {
                                      class: "odd",
                                      key: person.fullName
                                    }, [
                                      _createElementVNode("td", null, [
                                        _createElementVNode("div", _hoisted_80, [
                                          _createElementVNode("div", _hoisted_81, [
                                            (person.fullName !== '')
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_82, [
                                                  (!person.avatar)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_83, _toDisplayString(person.fullName[0]), 1))
                                                    : (_openBlock(), _createElementBlock("img", {
                                                        key: 1,
                                                        alt: "Pic",
                                                        src: person.avatar
                                                      }, null, 8, _hoisted_84))
                                                ]))
                                              : (_openBlock(), _createElementBlock("div", _hoisted_85, [
                                                  (!person.avatar)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_86, _toDisplayString(person.fullName[0]), 1))
                                                    : (_openBlock(), _createElementBlock("img", {
                                                        key: 1,
                                                        alt: "Pic",
                                                        src: person.avatar
                                                      }, null, 8, _hoisted_87))
                                                ]))
                                          ]),
                                          _createElementVNode("div", _hoisted_88, [
                                            _createElementVNode("div", {
                                              class: "mb-1 text-gray-800 text-hover-primary cursor-pointer",
                                              onClick: ($event: any) => (_ctx.invokeRequestResponse(person))
                                            }, _toDisplayString(person.fullName), 9, _hoisted_89),
                                            _createElementVNode("div", _hoisted_90, "invited on: " + _toDisplayString(_ctx.formatDate(person.joinedOn)), 1)
                                          ])
                                        ])
                                      ]),
                                      _createElementVNode("td", null, _toDisplayString(person.title), 1),
                                      _createElementVNode("td", _hoisted_91, [
                                        _createElementVNode("span", {
                                          class: _normalizeClass(`badge badge-light-${_ctx.getRole(person.role).class} text-white fw-bolder px-4 py-3`)
                                        }, _toDisplayString(_ctx.getRole(person.role).name), 3)
                                      ]),
                                      _createElementVNode("td", _hoisted_92, [
                                        _createElementVNode("span", {
                                          class: _normalizeClass(`badge badge-light-${_ctx.getStatus(person.status).class} text-white fw-bolder px-4 py-3`)
                                        }, _toDisplayString(_ctx.getStatus(person.status).name), 3)
                                      ]),
                                      _createElementVNode("td", _hoisted_93, [
                                        _createElementVNode("div", null, [
                                          (_ctx.getStatus(person.status).name === 'Pending Entity')
                                            ? (_openBlock(), _createBlock(_component_Button, {
                                                key: 0,
                                                onClick: ($event: any) => (_ctx.invokeRequestResponse(person)),
                                                "data-bs-toggle": "tooltip",
                                                "data-bs-placement": "top",
                                                title: "Respond to Request",
                                                class: "btn-link me-lg-2 btn-active-color-success",
                                                type: ""
                                              }, {
                                                default: _withCtx(() => [
                                                  _hoisted_94
                                                ]),
                                                _: 2
                                              }, 1032, ["onClick"]))
                                            : _createCommentVNode("", true)
                                        ])
                                      ])
                                    ]))
                                  }), 128))
                                ]))
                              : (_openBlock(), _createElementBlock("tbody", _hoisted_95, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.pendingInvitations, (person) => {
                                    return (_openBlock(), _createElementBlock("tr", {
                                      class: "odd",
                                      key: person.fullName
                                    }, [
                                      _createElementVNode("td", null, [
                                        _createElementVNode("div", _hoisted_96, [
                                          _createElementVNode("div", _hoisted_97, [
                                            (person.fullName !== '')
                                              ? (_openBlock(), _createElementBlock("div", _hoisted_98, [
                                                  (!person.avatar)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_99, _toDisplayString(person.fullName[0]), 1))
                                                    : (_openBlock(), _createElementBlock("img", {
                                                        key: 1,
                                                        alt: "Pic",
                                                        src: person.avatar
                                                      }, null, 8, _hoisted_100))
                                                ]))
                                              : (_openBlock(), _createElementBlock("div", _hoisted_101, [
                                                  (!person.avatar)
                                                    ? (_openBlock(), _createElementBlock("span", _hoisted_102, _toDisplayString(person.fullName[0]), 1))
                                                    : (_openBlock(), _createElementBlock("img", {
                                                        key: 1,
                                                        alt: "Pic",
                                                        src: person.avatar
                                                      }, null, 8, _hoisted_103))
                                                ]))
                                          ]),
                                          (person.fullName !== '')
                                            ? (_openBlock(), _createElementBlock("div", _hoisted_104, [
                                                _createElementVNode("div", _hoisted_105, _toDisplayString(person.fullName), 1),
                                                _createElementVNode("div", _hoisted_106, "invited on: " + _toDisplayString(_ctx.formatDate(person.joinedOn)), 1)
                                              ]))
                                            : (_openBlock(), _createElementBlock("div", _hoisted_107, [
                                                _createElementVNode("div", _hoisted_108, _toDisplayString(person.fullName), 1),
                                                _createElementVNode("div", _hoisted_109, "invited on: " + _toDisplayString(_ctx.formatDate(person.joinedOn)), 1)
                                              ]))
                                        ])
                                      ]),
                                      _createElementVNode("td", null, _toDisplayString(person.title), 1),
                                      _createElementVNode("td", _hoisted_110, [
                                        _createElementVNode("span", {
                                          class: _normalizeClass(`badge badge-light-${_ctx.getRole(person.role).class} text-white fw-bolder px-4 py-3`)
                                        }, _toDisplayString(_ctx.getRole(person.role).name), 3)
                                      ]),
                                      _createElementVNode("td", _hoisted_111, [
                                        _createElementVNode("span", {
                                          class: _normalizeClass(`badge badge-light-${_ctx.getStatus(person.status).class} text-white fw-bolder px-4 py-3`)
                                        }, _toDisplayString(_ctx.getStatus(person.status).name), 3)
                                      ]),
                                      _createElementVNode("td", _hoisted_112, [
                                        _createElementVNode("div", null, [
                                          (_ctx.getStatus(person.status).name === 'Pending Entity')
                                            ? (_openBlock(), _createBlock(_component_Button, {
                                                key: 0,
                                                onClick: ($event: any) => (_ctx.invokeRequestResponse(person)),
                                                "data-bs-toggle": "tooltip",
                                                "data-bs-placement": "top",
                                                title: "Respond to Request",
                                                class: "btn-link me-lg-2 btn-active-color-success",
                                                type: ""
                                              }, {
                                                default: _withCtx(() => [
                                                  _hoisted_113
                                                ]),
                                                _: 2
                                              }, 1032, ["onClick"]))
                                            : _createCommentVNode("", true),
                                          (_ctx.getStatus(person.status).name === 'Pending User')
                                            ? (_openBlock(), _createBlock(_component_Button, {
                                                key: 1,
                                                onClick: ($event: any) => (_ctx.rescindInvite(person)),
                                                "data-bs-toggle": "tooltip",
                                                "data-bs-placement": "top",
                                                title: "Rescind Invitation",
                                                class: "btn-link btn-active-color-danger me-4",
                                                type: ""
                                              }, {
                                                default: _withCtx(() => [
                                                  _hoisted_114
                                                ]),
                                                _: 2
                                              }, 1032, ["onClick"]))
                                            : _createCommentVNode("", true),
                                          (_ctx.getStatus(person.status).name === 'Pending User')
                                            ? (_openBlock(), _createBlock(_component_Button, {
                                                key: 2,
                                                "data-bs-toggle": "tooltip",
                                                "data-bs-placement": "top",
                                                title: "Resend Invitation Email",
                                                onClick: ($event: any) => (_ctx.resendInvite(person)),
                                                class: "btn-link btn-active-color-info",
                                                type: ""
                                              }, {
                                                default: _withCtx(() => [
                                                  _hoisted_115
                                                ]),
                                                _: 2
                                              }, 1032, ["onClick"]))
                                            : _createCommentVNode("", true)
                                        ])
                                      ])
                                    ]))
                                  }), 128))
                                ]))
                          ])
                        ]),
                        _hoisted_116
                      ])
                    ]))
                  : _createCommentVNode("", true)
              ])
            ])
          ])), [
            [_directive_loading, _ctx.peopleLoading]
          ])
        : _createCommentVNode("", true),
      (_ctx.applicationStore.peopleCurrentTab === 'groups')
        ? _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_117, [
            _createElementVNode("div", _hoisted_118, [
              _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_119, [
                (_ctx.groupsFiltered.length === 0)
                  ? (_openBlock(), _createBlock(_component_el_empty, {
                      key: 0,
                      description: "You don't have any groups."
                    }, {
                      image: _withCtx(() => [
                        _hoisted_120
                      ]),
                      default: _withCtx(() => [
                        _createVNode(_component_Button, {
                          onClick: _ctx.invokeAddGroup,
                          class: "btn-sm"
                        }, {
                          default: _withCtx(() => [
                            _createTextVNode("Add Group")
                          ]),
                          _: 1
                        }, 8, ["onClick"])
                      ]),
                      _: 1
                    }))
                  : (_openBlock(true), _createElementBlock(_Fragment, { key: 1 }, _renderList(_ctx.groupsFiltered, (group) => {
                      return (_openBlock(), _createElementBlock("div", {
                        key: group.groupId,
                        class: "d-flex flex-column"
                      }, [
                        _createElementVNode("div", _hoisted_121, [
                          _createElementVNode("div", _hoisted_122, [
                            _createElementVNode("div", {
                              class: "d-flex align-items-center collapsible rotate collapsed",
                              "data-bs-toggle": "collapse",
                              href: `#group_row_${group.groupId}`,
                              role: "button",
                              "aria-expanded": "true",
                              "aria-controls": "kt_customer_view_payment_method_1"
                            }, [
                              _hoisted_124,
                              _createElementVNode("div", _hoisted_125, [
                                _createElementVNode("div", {
                                  class: "d-flex align-items-center cursor-pointer",
                                  onClick: ($event: any) => (_ctx.invokeManageGroup(group))
                                }, [
                                  _createElementVNode("div", _hoisted_127, _toDisplayString(group.name), 1)
                                ], 8, _hoisted_126),
                                _createElementVNode("div", _hoisted_128, _toDisplayString(group.description), 1)
                              ])
                            ], 8, _hoisted_123),
                            _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_129, [
                              (!_ctx.isOrganization)
                                ? (_openBlock(), _createBlock(_component_Button, {
                                    key: 0,
                                    onClick: ($event: any) => (_ctx.requestMeasurementExport([group.groupId])),
                                    class: "btn-sm me-4"
                                  }, {
                                    default: _withCtx(() => [
                                      _createTextVNode("Export Measurements ")
                                    ]),
                                    _: 2
                                  }, 1032, ["onClick"]))
                                : _createCommentVNode("", true),
                              _createVNode(_component_Button, {
                                onClick: ($event: any) => (_ctx.requestExport([group.groupId])),
                                class: "btn-sm"
                              }, {
                                default: _withCtx(() => [
                                  _createTextVNode("Export Call Sheet")
                                ]),
                                _: 2
                              }, 1032, ["onClick"])
                            ])), [
                              [_directive_loading, _ctx.exportLoading]
                            ])
                          ]),
                          _createElementVNode("div", {
                            id: `group_row_${group.groupId}`,
                            class: "fs-6 ps-10 collapse"
                          }, [
                            _createElementVNode("div", _hoisted_131, [
                              (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(group.members, (member) => {
                                return (_openBlock(), _createElementBlock("div", {
                                  key: member,
                                  class: "me-4"
                                }, [
                                  _createVNode(_component_VerticalBullet, {
                                    text: _ctx.getGroupMember(member).fullName,
                                    color: "purple"
                                  }, null, 8, ["text"])
                                ]))
                              }), 128))
                            ])
                          ], 8, _hoisted_130)
                        ]),
                        _hoisted_132
                      ]))
                    }), 128))
              ])), [
                [_directive_loading, _ctx.groupsLoading]
              ])
            ])
          ])), [
            [_directive_loading, _ctx.groupsLoading]
          ])
        : _createCommentVNode("", true),
      (_ctx.applicationStore.peopleCurrentTab === 'measurements')
        ? (_openBlock(), _createBlock(_component_MeasurementsTable, {
            key: 4,
            people: _ctx.people
          }, null, 8, ["people"]))
        : _createCommentVNode("", true)
    ]),
    _createVNode(_component_ManagePersonModal, {
      onUpdated: _ctx.fetch,
      ref: "managePersonModal",
      groups: _ctx.groups
    }, null, 8, ["onUpdated", "groups"]),
    _createVNode(_component_GroupModal, {
      ref: "groupModal",
      people: _ctx.people
    }, null, 8, ["people"]),
    _createVNode(_component_AddPeopleModal, {
      onAdded: _ctx.fetch,
      ref: "addPeopleModal"
    }, null, 8, ["onAdded"]),
    _createVNode(_component_EntityRequestModal, {
      onUpdated: _ctx.fetch,
      ref: "entityRequestModal",
      groups: _ctx.groups
    }, null, 8, ["onUpdated", "groups"]),
    _createVNode(_component_ViewPersonModal, {
      ref: "viewPersonModal",
      groups: _ctx.groups
    }, null, 8, ["groups"])
  ]))
}